import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"font-weight-bold\">Anwesenheit</h1><div class=\"alert alert-dark-100 alert-styled-left alert-arrow-left alert-dismissible\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\"><span>×</span></button> Normalerweise wird unabhängig von einem Zeitplan die Intervention nach Alarmplan ausgeführt. Z.B. Ganztätig - bei Einbruchalarm - werden als erstes die Kontaktpersonen alarmiert und wenn diese nicht erreichbar sind im Anschluss die Polizei. <br><br> Mit diesem Zeitplan können Sie den Alarmplan erweitern. Außerhalb der eingestellten Zeit kann anders alarmiert werden als innerhalb dieser Zeit. <br><br><u>Beispiel:</u><br><em> Sie stellen 06:00 - 22:00 Uhr ein. Bei Interventionen können Sie nun konfigurieren, was innerhalb und außerhalb dieser Zeiten passieren soll.<br> Innerhalb der Zeit (06:00 - 22:00 Uhr), sollen erst die Kontaktpersonen und danach die Polizei alarmiert werden. Außerhalb der Zeit, soll erst die Polizei und danach die Kontaktpersonen alarmiert werden. </em><br><br> Dieser Zeitplan wird für das Objekt eingestellt. Eine Konfiguration <b>je Anlage oder je Ereignis</b> ist <b>nicht</b> möglich. <br><br> Bei Fragen wenden Sie sich gern an Ihren Errichter. </div>", 2)
const _hoisted_4 = { class: "row mt-4" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = { class: "font-size-lg" }
const _hoisted_7 = { class: "col-12 text-right mt-4" }
const _hoisted_8 = { class: "card mt-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Dieser Zeitplan wird in folgenden Interventionen verwendet ")
], -1)
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "table-active" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Anlage"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Ereignis")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TimeRangeSLider = _resolveComponent("TimeRangeSLider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form, (day, dayIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: dayIndex,
            class: "form-group"
          }, [
            _createElementVNode("label", null, [
              _createElementVNode("b", _hoisted_6, _toDisplayString(day.name), 1)
            ]),
            _createVNode(_component_TimeRangeSLider, {
              start: day.start,
              "onUpdate:start": ($event: any) => ((day.start) = $event),
              end: day.end,
              "onUpdate:end": ($event: any) => ((day.end) = $event)
            }, null, 8, ["start", "onUpdate:start", "end", "onUpdate:end"])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveTimes && _ctx.saveTimes(...args)))
        }, " Speichern ")
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("table", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usages, (usage, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(usage.systemName), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.interventionTypes[usage.intervention]['name']), 1)
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}